/* eslint-disable react-hooks/exhaustive-deps */
import { useRouter } from 'next/router'
import React, { createContext, useEffect, useState, ReactNode } from 'react'

export type SideMenuLeftStateType = {
  open: boolean;
}

export type DrawersContextType = {
  sideMenuLeftState: SideMenuLeftStateType;
  handleSideMenuLeft: (P: SideMenuLeftStateType) => void;
}

export interface DrawersProviderProps {
  children: ReactNode;
}

export const DrawersContext = createContext({} as DrawersContextType)

const DrawersProvider: React.FC<DrawersProviderProps> = ({ children }) => {

  const router = useRouter()
  const [sideMenuLeftState, setSideMenuLeft] = useState<SideMenuLeftStateType>({ open: false })

  function handleSideMenuLeft(state) {
    setSideMenuLeft(state)
  }

  useEffect(() => {
    if (sideMenuLeftState.open === true) {
      setSideMenuLeft({ open: false })
    }
  }, [router.asPath])

  return (
    <DrawersContext.Provider
      value={{
        sideMenuLeftState,
        handleSideMenuLeft
      }}
    >
      {children}
    </DrawersContext.Provider>
  )
}

export default DrawersProvider
